/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../Component/utils/axiosInstance";
import Loader from "../../Component/Loader";
import { imgUrl } from "../utils/imgUrl";

export default function EasyToOrder() {
  const [loader, setLoader] = useState(false);
  const [sliderImage, setSliderImage] = useState([]);
  const getSliderImage = async () => {
    setLoader(true);
    try {
      await axiosInstance.get("user/sliderimage").then((response) => {
        if (response?.data?.status === true) {
          setLoader(false);
          setSliderImage(response?.data?.slider_image);
        }
      });
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    getSliderImage();
  }, []);

  return (
    <div>
      {loader && <Loader />}
      <section className="download mt_100 xs_mt_70">
        <div className="row">
          <div className="col-xl-4 col-lg-4">
            <div
              className="download_text_bg"
              style={{
                background: `url(${imgUrl + sliderImage?.image1})`,
              }}
            >
              <div className="download_text_overlay">
                {/* <div
                  className="download_text wow fadeInUp"
                  data-wow-duration="1s"
                >
                  <h5>$5.00 Cashback</h5>
                  <h2>Easy To Order Our All Food</h2>
                  <ul className="d-flex flex-wrap">
                    <li>
                      <a>
                        <span className="icon">
                          <i className="fab fa-google-play" />
                        </span>
                        <p>
                          <span>Available on the</span>
                          Google Play
                        </p>
                      </a>
                    </li>
                    <li>
                      <a>
                        <span className="icon">
                          <i className="fab fa-apple" />
                        </span>
                        <p>
                          <span>Download on the</span>
                          App Store
                        </p>
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-xl-8 col-lg-block d-xl-block d-lg-block d-md-block d-none">
            <div className="row h-100">
              <div
                className="col-xl-3 wow fadeInUp h-100"
                data-wow-duration="1s"
              >
                <div className=" h-100">
                  <img
                    src={imgUrl + sliderImage?.image2}
                    alt="app download"
                    className="h-100"
                  />
                </div>
              </div>

              <div
                className="col-xl-3 wow fadeInUp h-100"
                data-wow-duration="1s"
              >
                <div className=" h-100">
                  <img
                    src={imgUrl + sliderImage?.image3}
                    alt="app download"
                    className="h-100"
                  />
                </div>
              </div>

              <div
                className="col-xl-3 wow fadeInUp h-100"
                data-wow-duration="1s"
              >
                <div className=" h-100">
                  <img
                    src={imgUrl + sliderImage?.image4}
                    alt="app download"
                    className="h-100"
                  />
                </div>
              </div>

              <div
                className="col-xl-3 wow fadeInUp h-100"
                data-wow-duration="1s"
              >
                <div className=" h-100">
                  <img
                    src={imgUrl + sliderImage?.image5}
                    alt="app download"
                    className="h-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
